import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ContentLoading } from '@/components/ContentLoading'
import { ContentError } from '@/components/ContentError'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { type JobDocumentListViewModel } from '@/features/documents/JobDocumentListViewModel'
import {
  DocumentList,
  DocumentListItems,
} from '@/features/documents/components/DocumentList'
import { DocumentListItemContainer } from '@/features/documents/components/DocumentListItem/DocumentListItemContainer'

export interface DocumentListContainerProps {
  vm: JobDocumentListViewModel
  selectable?: boolean
  compact?: boolean
  showIcon?: boolean
}

export const DocumentListContainer = observer(function DocumentListContainer({
  vm,
  selectable,
  compact,
  showIcon,
}: DocumentListContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <DocumentList>
      {vm.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => (
          <DocumentListItems
            isEmpty={vm.documentVms.length === 0}
            canUploadDocs={vm.canUploadDocs}
            compact={compact}
            corporateMode={shellInfo.corporateMode}
          >
            {vm.documentVms.map((documentVm) => (
              <div key={documentVm.document.id}>
                <DocumentListItemContainer
                  vm={documentVm}
                  selectable={selectable}
                  showIcon={showIcon}
                />
              </div>
            ))}
            <InfiniteScrollLoaderContainer scrollProvider={vm.scrollProvider} />
          </DocumentListItems>
        ),
      })}
    </DocumentList>
  )
})
